import { observer } from 'mobx-react';
import UseCaseDropdownMenu from './UseCaseDropdownMenu';

function UseCaseMenu() {
  return <UseCaseDropdownMenu />;
}

export default observer(UseCaseMenu);
